<template>
    <nav class="menu-navbar">
        <ul>
            <li>
                <router-link class="nb-link" to="/">
                    <span class="nb-icon"><i class="bi bi-android2"></i></span>
                    <span class="nb-link-text">Боты</span>
                </router-link>
            </li>
            <li>
                <router-link class="nb-link" to="/sender">
                    <span class="nb-icon"
                        ><i class="bi bi-send-plus"></i
                    ></span>
                    <span class="nb-link-text">Создать рассылку</span>
                </router-link>
            </li>
            <li>
              <router-link class="nb-link" to="/broadcast_status">
                      <span class="nb-icon"
                      ><i class="bi bi-clock-history"></i
                      ></span>
                <span class="nb-link-text">Статус рассылок</span>
              </router-link>
            </li>
            <li>
              <router-link class="nb-link" to="/projects">
                        <span class="nb-icon"
                        ><i class="bi bi-kanban"></i
                        ></span>
                <span class="nb-link-text">Проекты</span>
              </router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'TopNav',
}
</script>
